import { ReactElement } from 'react';
import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import { ResearchFilterMunicipalNumberVM } from 'civil-status/view-models/municipal-number';
import ListRegister from '../../shared/list-register';
import { DatePicker } from '@mui/lab';
import StateList from '../list/state-list';
import OperatorList from 'civil-status/components/shared/operator-list';

const ResearchFilterMunicipalNumber = (): ReactElement => {
  const formContext = useFormikContext<ResearchFilterMunicipalNumberVM>();

  const onChangeRegister = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('register', event.target.value);
  });

  const onChangeStateList = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('state', event.target.value);
  });

  const onChangeOperator = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('operator', event.target.value);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <ListRegister
          value={formContext.values.register || ''}
          error={Boolean(formContext.errors.register) && formContext.touched.register}
          onChange={onChangeRegister}
          withNessuno
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Richiesta da *"
          aria-label="Richiesta da"
          value={formContext.values?.dateFrom || null}
          onChange={(date) => formContext.setFieldValue('dateFrom', date)}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateFrom"
              fullWidth
              error={formContext.touched?.dateFrom && Boolean(formContext.errors?.dateFrom)}
              helperText={formContext.errors?.dateFrom}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Richiesta a *"
          aria-label="Richiesta a"
          value={formContext.values?.dateTo || null}
          onChange={(date) => formContext.setFieldValue('dateTo', date)}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateTo"
              fullWidth
              error={formContext.touched?.dateTo && Boolean(formContext.errors?.dateTo)}
              helperText={formContext.errors?.dateTo}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <OperatorList onChange={onChangeOperator} value={formContext.values.operator || ''} />
      </Grid>
      <Grid item xs={12} md={4}>
        <StateList value={formContext.values?.state || ''} onChange={onChangeStateList} />
      </Grid>
      <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center' }}>
        <PmiButton variant="outlined" color="cdmBrandThird" fullWidth type="submit">
          Cerca
        </PmiButton>
      </Grid>
    </Grid>
  );
};

ResearchFilterMunicipalNumber.displayName = 'Research Filter Municipal Number Form component';

export default ResearchFilterMunicipalNumber;
